import Vue from "vue";
import Router from "vue-router";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
// const Welcome = () => import('@/views/pages/Welcome')
const Index = () => import("@/views/pages/Index");
const ChatFlow = () => import("@/views/pages/flow-builder/index");
const Overview = () => import("@/views/pages/bot-analysis/overview");
const RealTime = () => import("@/views/pages/bot-analysis/real-time");
const ProductivityReport = () => import("@/views/pages/bot-analysis/productivity-report/index");
const ChatAnalysis = () => import("@/views/pages/chat-analysis/index");
const MessageLog = () => import("@/views/pages/message-log/index");
const MessageLogDetail = () => import("@/views/pages/message-log/Details");
const SettingTime = () => import("@/views/pages/setting-time/index");
const SettingChat = () => import("@/views/pages/setting-chat/Index");
const SettingWidget = () => import("@/views/pages/setting-widget/Index");
const User = () => import("@/views/pages/user/Index");
const UserDetail = () => import("@/views/pages/user/Details");
const SentimentTraining = () =>
  import("@/views/pages/sentiment-training/index");
const FlowwayTraining = () => import("@/views/pages/flowway-training/index");
const ImageMap = () => import("@/views/pages/image-map/index");
const EmailConfig = () => import("@/views/pages/email-config/Index");
const Page403 = () => import("@/views/pages/Page403");
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Live = () => import("@/views/pages/live/Index");
const LiveDetail = () => import("@/views/pages/live/Detail");
const LiveEdit = () => import("@/views/pages/live/Edit");
const SettingIndex = () => import("@/views/pages/setting/Index");
const SettingBrand = () => import("@/views/pages/setting-brand/Index");
const Team = () => import("@/views/pages/team/Index");
const TeamDetail = () => import("@/views/pages/team/Detail");
const ApiTrigger = () => import("@/views/pages/api-trigger/Index");
const ApiTriggerDetail = () => import("@/views/pages/api-trigger/Detail");
const Webhook = () => import("@/views/pages/webhook/Index");
const WebhookDetail = () => import("@/views/pages/webhook/Detail");
const Customer = () => import("@/views/pages/customer/Index");
const CustomerDetails = () => import("@/views/pages/customer/Detail");
const Variable = () => import("@/views/pages/variable/Index");
const SettingConfig = () => import("@/views/pages/setting-config/Index");
const SettingPlugin = () => import("@/views/pages/setting-plugin/Index");
const WaitTime = () => import("@/views/pages/wait-time/Index");
const ResolutionTime = () => import("@/views/pages/resolution-time/Index");
const ConversationTopic = () =>
  import("@/views/pages/conversation-topic/Index");
const SettingEmailTemplate = () =>
  import("@/views/pages/setting-email-template/Index");
const SettingEmailTemplateDetail = () =>
  import("@/views/pages/setting-email-template/Detail");
const SettingRole = () => import("@/views/pages/setting-role/Index");

const SettingSlaPolicy = () => import("@/views/pages/setting-sla-policy/Index");
const SettingSlaPolicyTemplateDetail = () =>
  import("@/views/pages/setting-sla-policy/Detail");

const SettingWhatsAppTemplate = () =>
  import("@/views/pages/setting-whatsapp/Index");
const SettingWhatsAppTemplateDetail = () =>
  import("@/views/pages/setting-whatsapp/Detail");
const CallBackOAuth = () => import("@/views/pages/setting-brand/callback");

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { 
        requiresIsLogin: true, 
        permissionId: -1,
      },
    },
    {
      path: "/callback",
      name: "Meta Callback",
      component: CallBackOAuth,
    },
    {
      path: "/",
      redirect: "/",
      name: "Container",
      component: TheContainer,
      meta: { requiresAuth: true },
      children: [
        {
          path: "/",
          name: "INDEX",
          component: Index,
          meta: {
            requiresAuth: true,
            permissionId: -1,
          },
        },
        {
          path: "/flow-builder",
          name: "FLOW BUILDER",
          component: ChatFlow,
          meta: {
            requiresAuth: true,
            activeUrl: "/flow-builder",
            parent: "/flow-builder",
            isChildren: true,
            permissionId: 1,
            lv: 1,
          },
        },
        // {
        //   path: "/chat-analysis",
        //   name: "CHAT ANALYSIS",
        //   component: ChatAnalysis,
        //   meta: {
        //     requiresAuth: true,
        //     activeUrl: "/chat-analysis",
        //     parent: "/chat-analysis",
        //     isChildren: true,
        //     permissionId: 2,
        //     lv: 1,
        //   },
        // },
        {
          path: "/overview",
          name: "OVERVIEW",
          component: Overview,
          meta: {
            requiresAuth: true,
            activeUrl: "/overview",
            parent: "/overview",
            isChildren: true,
            permissionId: 17,
            lv: 2,
          },
        },
        {
          path: "/in-conversation",
          name: "IN CONVERSATION",
          component: RealTime,
          meta: {
            requiresAuth: true,
            activeUrl: "/in-conversation",
            parent: "/in-conversation",
            isChildren: true,
            permissionId: 18,
            lv: 2,
          },
        },
        {
          path: "/productivity-report",
          name: "PRODUCTIVITY REPORT",
          component: ProductivityReport,
          meta: {
            requiresAuth: true,
            activeUrl: "/productivity-report",
            parent: "/productivity-report",
            isChildren: true,
            permissionId: 31,
            lv: 2,
          },
        },
        {
          path: "/image-map",
          name: "IMAGE MAP",
          component: ImageMap,
          meta: {
            requiresAuth: true,
            activeUrl: "/image-map",
            parent: "/image-map",
            isChildren: true,
            permissionId: 4,
            lv: 1,
          },
        },
        {
          path: "/sentiment-training",
          name: "SENTIMENT TRAINING",
          component: SentimentTraining,
          meta: {
            requiresAuth: true,
            activeUrl: "/sentiment-training",
            parent: "/sentiment-training",
            isChildren: true,
            permissionId: 5,
            lv: 1,
          },
        },
        {
          path: "/flowway-training",
          name: "FLOW WAY TRAINING",
          component: FlowwayTraining,
          meta: {
            requiresAuth: true,
            activeUrl: "/flowway-training",
            parent: "/flowway-training",
            isChildren: true,
            permissionId: 6,
            lv: 1,
          },
        },
        {
          path: "/setting-time",
          name: "SETTING TIME LIST",
          component: SettingTime,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting-time",
            parent: "/setting-time",
            isChildren: true,
            permissionId: 7,
            lv: 1,
          },
        },
        {
          path: "/setting-chat",
          name: "CHAT SETTING",
          component: SettingChat,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting-chat",
            parent: "/setting-chat",
            isChildren: true,
            permissionId: 25,
            lv: 2,
          },
        },
        {
          path: "/setting-widget",
          name: "SETTING WIDGET",
          component: SettingWidget,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting-widget",
            parent: "/setting-widget",
            isChildren: true,
            permissionId: 0,
            lv: 1,
          },
        },
        {
          path: "/email-config",
          name: "EMAIL CONFIG",
          component: EmailConfig,
          meta: {
            requiresAuth: true,
            activeUrl: "/email-config",
            parent: "/email-config",
            isChildren: true,
            permissionId: 0,
            lv: 1,
          },
        },
        {
          path: "/setting",
          name: "SETTING",
          component: SettingIndex,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting",
            parent: "/setting",
            isChildren: true,
            permissionId: 29,
            lv: 2,
          },
        },
        {
          path: "/setting-brand",
          name: "SETTING BRAND LIST",
          component: SettingBrand,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting-brand",
            parent: "/setting-brand",
            isChildren: true,
            permissionId: 19,
            lv: 2,
          },
        },
        {
          path: "/setting-config",
          name: "SETTING CONFIG",
          component: SettingConfig,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting-config",
            parent: "/setting-config",
            isChildren: true,
            permissionId: 20,
            lv: 2,
          },
        },
        {
          path: "/setting-plugin",
          name: "PLUGIN",
          component: SettingPlugin,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting-plugin",
            parent: "/setting-plugin",
            isChildren: true,
            permissionId: 21,
            lv: 2,
          },
        },
        {
          path: "/setting-sla-policy",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 28,
            parent: "/setting-sla-policy",
            activeUrl: "/setting-sla-policy",
            lv: 2,
          },
          children: [
            {
              path: "",
              name: "SLA POLICY",
              component: SettingSlaPolicy,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 28,
                parent: "/setting-sla-policy",
                activeUrl: "/setting-sla-policy",
                lv: 2,
              },
            },
            {
              path: "",
              redirect: "/setting-sla-policy",
              name: "SLA POLICY",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "create",
                  name: "SLA POLICY CREATE",
                  component: SettingSlaPolicyTemplateDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 28,
                    parent: "/setting-sla-policy",
                    activeUrl: "/setting-sla-policy",
                    lv: 2,
                  },
                },
                {
                  path: ":id",
                  name: "SLA POLICY DETAILS",
                  component: SettingSlaPolicyTemplateDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 28,
                    parent: "/setting-sla-policy",
                    activeUrl: "/setting-sla-policy",
                    lv: 2,
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/wait-time",
          name: "WAIT TIME",
          component: WaitTime,
          meta: {
            requiresAuth: true,
            activeUrl: "/wait-time",
            parent: "/wait-time",
            isChildren: true,
            permissionId: 22,
            lv: 2,
          },
        },
        {
          path: "/resolution-time",
          name: "RESOLUTION TIME",
          component: ResolutionTime,
          meta: {
            requiresAuth: true,
            activeUrl: "/resolution-time",
            parent: "/resolution-time",
            isChildren: true,
            permissionId: 23,
            lv: 2,
          },
        },
        {
          path: "/conversation-topic",
          name: "CONVERSATION TOPIC",
          component: ConversationTopic,
          meta: {
            requiresAuth: true,
            activeUrl: "/conversation-topic",
            parent: "/conversation-topic",
            isChildren: true,
            permissionId: 24,
            lv: 2,
          },
        },
        {
          path: "/email-template",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 26,
            parent: "/email-template",
            activeUrl: "/email-template",
            lv: 2,
          },
          children: [
            {
              path: "",
              name: "EMAIL TEMPLATE",
              component: SettingEmailTemplate,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 26,
                parent: "/email-template",
                activeUrl: "/email-template",
                lv: 2,
              },
            },
            {
              path: "",
              redirect: "/email-template",
              name: "EMAIL TEMPLATE",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "create",
                  name: "EMAIL TEMPLATE CREATE",
                  component: SettingEmailTemplateDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 26,
                    parent: "/email-template",
                    activeUrl: "/email-template",
                    lv: 2,
                  },
                },
                {
                  path: ":id",
                  name: "EMAIL TEMPLATE DETAILS",
                  component: SettingEmailTemplateDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 26,
                    parent: "/email-template",
                    activeUrl: "/email-template",
                    lv: 2,
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/setting-role",
          name: "ROLE",
          component: SettingRole,
          meta: {
            requiresAuth: true,
            activeUrl: "/setting-role",
            parent: "/setting-role",
            isChildren: true,
            permissionId: 27,
            lv: 2,
          },
        },
        {
          path: "/webhook",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 13,
            activeUrl: "/webhook",
            lv: 1,
          },
          children: [
            {
              path: "",
              name: "WEBHOOK LIST",
              component: Webhook,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 13,
                activeUrl: "/webhook",
              },
            },
            {
              path: "",
              redirect: "/webhook",
              name: "WEBHOOK LIST",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "create",
                  name: "WEBHOOK CREATE",
                  component: WebhookDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 13,
                    activeUrl: "/webhook",
                  },
                },
                {
                  path: ":id",
                  name: "WEBHOOK DETAILS",
                  component: WebhookDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 13,
                    activeUrl: "/webhook",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/customer",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 15,
            activeUrl: "/customer",
            lv: 1,
          },
          children: [
            {
              path: "",
              name: "CUSTOMER LIST",
              component: Customer,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 15,
                activeUrl: "/customer",
              },
            },
            {
              path: "",
              redirect: "/customer",
              name: "CUSTOMER LIST",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "detail/:id",
                  name: "CUSTOMER DETAILS",
                  component: CustomerDetails,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 15,
                    activeUrl: "/customer",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/message-log",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 3,
            activeUrl: "/message-log",
            lv: 1,
          },
          children: [
            {
              path: "",
              name: "MESSAGE LOG LIST",
              component: MessageLog,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 3,
                activeUrl: "/message-log",
              },
            },
            {
              path: "",
              redirect: "/message-log",
              name: "MESSAGE LOG LIST",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "details/:id/:activityId",
                  name: "MESSAGE LOG DETAILS",
                  component: MessageLogDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 3,
                    activeUrl: "/message-log",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/chat",
          name: "CHAT",
          meta: {
            requiresAuth: true,
            activeUrl: "/chat",
            parent: "/chat",
            permissionId: 16,
            lv: 1,
          },
        },
        {
          path: "/user",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 8,
            activeUrl: "/user",
            lv: 1,
          },
          children: [
            {
              path: "",
              name: "USER LIST",
              component: User,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 8,
                activeUrl: "/user",
              },
            },
            {
              path: "",
              redirect: "/user",
              name: "USER LIST",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "details/:id",
                  name: "USER DETAILS",
                  component: UserDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 8,
                    activeUrl: "/user",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/team",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 11,
            activeUrl: "/team",
            lv: 1,
          },
          children: [
            {
              path: "",
              name: "TEAM LIST",
              component: Team,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 11,
                activeUrl: "/team",
              },
            },
            {
              path: "",
              redirect: "/team",
              name: "TEAM LIST",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "create",
                  name: "TEAM CREATE",
                  component: TeamDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 11,
                    activeUrl: "/team",
                  },
                },
                {
                  path: ":id",
                  name: "TEAM DETAILS",
                  component: TeamDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 11,
                    activeUrl: "/team",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/api-trigger",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 12,
            activeUrl: "/api-trigger",
            lv: 1,
          },
          children: [
            {
              path: "",
              name: "API TRIGGER LIST",
              component: ApiTrigger,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 12,
                activeUrl: "/api-trigger",
              },
            },
            {
              path: "",
              redirect: "/api-trigger",
              name: "API TRIGGER LIST",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "create",
                  name: "API TRIGGER CREATE",
                  component: ApiTriggerDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 12,
                    activeUrl: "/api-trigger",
                  },
                },
                {
                  path: ":id",
                  name: "API TRIGGER DETAILS",
                  component: ApiTriggerDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 12,
                    activeUrl: "/api-trigger",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/live",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 9,
            activeUrl: "/live",
            lv: 1,
          },
          children: [
            {
              path: "",
              name: "LIVE LIST",
              component: Live,
              meta: {
                requiresAuth: true,
                isChildren: true,
                permissionId: 9,
                activeUrl: "/live",
              },
            },
            {
              path: "",
              redirect: "/live",
              name: "LIVE LIST",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "detail/:id",
                  name: "LIVE DETAILS",
                  component: LiveDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 9,
                    activeUrl: "/live",
                  },
                },
                {
                  path: "create/:postTypeId/:id",
                  name: "LIVE CREATE",
                  component: LiveEdit,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 9,
                    activeUrl: "/live",
                  },
                },
                {
                  path: "edit/:postTypeId/:id",
                  name: "LIVE EDIT",
                  component: LiveEdit,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    permissionId: 9,
                    activeUrl: "/live",
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/whatsapp-template",
          name: "",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          meta: {
            requiresAuth: true,
            isChildren: true,
            parent: "/whatsapp-template",
            activeUrl: "/whatsapp-template",
            permissionId: 30,
            lv: 2,
          },
          children: [
            {
              path: "",
              name: "WhatsApp TEMPLATE",
              component: SettingWhatsAppTemplate,
              meta: {
                requiresAuth: true,
                isChildren: true,
                parent: "/whatsapp-template",
                activeUrl: "/whatsapp-template",
                permissionId: 30,
                lv: 2,
              },
            },
            {
              path: "",
              redirect: "/whatsapp-template",
              name: "WhatsApp TEMPLATE",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "create",
                  name: "WhatsApp TEMPLATE CREATE",
                  component: SettingWhatsAppTemplateDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    parent: "/whatsapp-template",
                    activeUrl: "/whatsapp-template",
                    permissionId: 30,
                    lv: 2,
                  },
                },
                {
                  path: ":id",
                  name: "WhatsApp TEMPLATE DETAILS",
                  component: SettingWhatsAppTemplateDetail,
                  meta: {
                    requiresAuth: true,
                    isChildren: true,
                    parent: "/whatsapp-template",
                    activeUrl: "/whatsapp-template",
                    permissionId: 30,
                    lv: 2,
                  },
                },
              ],
            },
          ],
        },
        {
          path: "/variable",
          name: "VARIABLE LIST",
          component: Variable,
          meta: {
            requiresAuth: true,
            isChildren: true,
            permissionId: 14,
            activeUrl: "/variable",
            lv: 1,
          },
        },
        {
          path: "/500",
          name: "Page500",
          component: Page500,
          meta: {
            requiresAuth: true,
            permissionId: -1,
          },
        },
        {
          path: "/403",
          name: "Page403",
          component: Page403,
          meta: {
            requiresAuth: true,
            permissionId: -1,
          },
        },
        {
          path: "/400",
          name: "Page404",
          component: Page404,
          meta: {
            requiresAuth: true,
            permissionId: -1,
          },
        },
        {
          path: "*",
          name: "Page404",
          component: Page404,
          meta: {
            requiresAuth: true,
            permissionId: -1,
          },
        },
      ],
    },
  ],
});
